'use strict'

define ['./applicationShareModal.css'], () ->
  ($q, $scope, $rootScope, $uibModalInstance, ApplicationBundle, Flash) ->
    check_svg = require('../../images/report-status-icon-ready.svg')
    $scope.theme_color = $rootScope.THEME_COLOR
    $scope.is_sharing = false
    $scope.state = 'main'
    $scope.show_user_type_dropdown = false
    $scope.show_decisioning_dropdown = false
    $scope.show_reports_dropdown = false

    $scope.reset_values = () ->
      $scope.show_user_type_dropdown = false
      $scope.show_decisioning_dropdown = false
      $scope.show_reports_dropdown = false
      $scope.sharee_name = ""
      $scope.sharee_email = ""
      $scope.user_type = null
      $scope.decisioning = null
      $scope.reports = null
      $scope.email_body = ""
    
    $scope.reset_values()

    $scope.create_new_share = () ->
      $scope.state = 'add'
    
    $scope.go_back_to_main = () ->
      $scope.reset_values()
      $scope.state = 'main'

    $scope.user_types = [
      {'label': "brokerage", 'value': "Agent"}, 
      {'label': "property_manager", 'value': "Property Manager"}, 
      {'label': "landlord", 'value': "Independent Landlord"}, 
    ]

    $scope.user_types_map = {
      brokerage: "Agent",
      property_manager: "Property Manager",
      landlord: "Independent Landlord"
    }

    $scope.boolean_types = [
      {'label': true, 'value': "Yes"}, 
      {'label': false, 'value': "No"}
    ]

    $scope.toggle_user_type_dropdown= () ->
      $scope.show_user_type_dropdown = !$scope.show_user_type_dropdown
    
    $scope.toggle_decisioning_dropdown= () ->
      $scope.show_decisioning_dropdown = !$scope.show_decisioning_dropdown
    
    $scope.toggle_reports_dropdown= () ->
      $scope.show_reports_dropdown = !$scope.show_reports_dropdown

    $scope.update_user_type = (type) ->
      $scope.user_type = type
      $scope.toggle_user_type_dropdown()
    
    $scope.update_decisioning = (val) ->
      $scope.decisioning = val
      $scope.toggle_decisioning_dropdown()
    
    $scope.update_reports = (val) ->
      $scope.reports = val
      $scope.toggle_reports_dropdown()
    
    # application_sharees = []
    # $scope.bundles.forEach (bundle) ->
    #   sharee = { "applicant_name": bundle.applications[0].applicant_name }
    #   sharee_emails = []
    #   bundle.sharees.forEach (sharee) ->
    #     sharee_emails.push sharee.username
    #   _.pull(sharee_emails, $scope.user.email)
    #   if sharee_emails.length != 0
    #     sharee.sharee_emails = sharee_emails
    #     application_sharees.push sharee
    # $scope.application_sharees = application_sharees

    $scope.share_applications = () ->
      if not $scope.sharee_email or $scope.decisioning == null or $scope.user_type == null or $scope.reports == null
        Flash.create('danger', 'Please enter all required fields.', 6000, { container: 'share-modal-flash'})
        return
      if $scope.email == $scope.user.username
        Flash.create('danger', 'You cannot share the application to yourself.', 6000, { container: 'share-modal-flash'})
        return
      $scope.is_sharing = true
      promises = []
      content =
        body: $scope.email_body

      share_data = 
        sharee_email: $scope.sharee_email,
        name: $scope.sharee_name,
        email_contents: content, 
        user_type: if $scope.user_type then $scope.user_type.label else "",
        decisioning: if $scope.decisioning then $scope.decisioning.label else false,
        reports: if $scope.reports then $scope.reports.label else false
      
      ApplicationBundle.share(id: $scope.bundle.id, share_data).$promise
        .then (resp) ->
          $scope.is_sharing = false
          $scope.state = 'complete'
          # Set the bundle with new updated bundle with shares
          $rootScope.$broadcast('application-bundle-updated', resp)
        .catch () ->
          console.log('error')
          $scope.is_sharing = false



// WEBPACK FOOTER //
// ./directives/applicationShareModal/applicationShareModal.coffee